<!-- <form [formGroup]="addDeleiveryGroupFormGroup" (ngSubmit)="addButtonClick()"> -->
<div class="whole-modal">
    <div class="modal-header">
        <div class="d-flex align-items-center justify-content-between w-100">
            <div class="d-flex align-items-center">
                <a class="close-icon" href="javascript:void()" (click)="closeClick()" ngbAutofocus><i class="flaticon2-cross"></i></a>
            </div>
        </div>
    </div>

    <div class="modal-body output-lable activity_body">
        <div class="setting-main-wrapper">
            <div class="row">
                <div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12">
                    <div class="div-wrapper lookup-wrapper" [ngClass]="DeliveryGroupList.length == 0 ? 'no-field-wrapper' : ''">
                        <div class="lookup-head">
                            <h4>{{ 'SETTING_PAGE.IDMS_SETTINGS.DELIVERY_GROUPS' | transloco }}</h4>
                            <div class="icon-wrapper">
                                <button class="btn primary-ebtn" *ngIf="iscreateRule" (click)="addNewRow()">
                                    <mat-icon class="" matTooltip="{{ 'SETTING_PAGE.IDMS_SETTINGS.ADD' | transloco }}">add</mat-icon>
                                </button>
                                <button class="btn primary-ebtn" [disabled]="disableEdit" (click)="saveAllChanges()">
                                    <mat-icon class=" " matTooltip="{{ 'SETTING_PAGE.IDMS_SETTINGS.SAVE' | transloco }}">save</mat-icon>
                                </button>
                                <button class="btn primary-ebtn" [disabled]="disableCancel" (click)="undoAllChanges()">
                                    <mat-icon class=" " matTooltip="{{ 'SETTING_PAGE.IDMS_SETTINGS.UNDO' | transloco }}">undo</mat-icon>
                                </button>
                            </div>
                        </div>

                        <div id="tree-list-demo" class="field-wrapper">
                            <dx-tree-list
                                class="tree-list-2"
                                #treeList
                                [dataSource]="DeliveryGroupList"
                                [parentIdExpr]="'parentId'"
                                keyExpr="id"
                                [expandedRowKeys]="[1]"
                                [showRowLines]="true"
                                [showBorders]="true"
                                [columnAutoWidth]="true"
                                [wordWrapEnabled]="true"
                                [showColumnHeaders]="false"
                                (onInitNewRow)="initNewRow($event)"
                                (onRowInserted)="onRowInserted($event)"
                                (onRowUpdated)="onRowUpdated($event)"
                                (onRowRemoved)="onRowRemoved($event)"
                                (onToolbarPreparing)="customizeToolbar($event)"
                                (onCellPrepared)="handleCellPrepared($event)"
                                (onCellValueChanged)="trackEditedCell($event)"
                                (onSaving)="handleSaving($event)"
                                (onRowPrepared)="handleRowPrepared($event)"
                                (onRowRemoving)="handleRowRemoving($event)"
                                (deleteRow)="handledeleteRow($event)"
                                (undeleteRow)="handleundeleteRow($event)"
                                (onOptionChanged)="handlePropertyChange($event)"
                                (onEditorPreparing)="onEditorPreparingDBSelect($event)"
                            >
                                <dxo-editing mode="batch" [allowDeleting]="true" [allowAdding]="allowAdding" [allowUpdating]="true" [useIcons]="true">
                                </dxo-editing>
                                <dxi-column dataField="name" [minWidth]="250">
                                    <dxi-validation-rule type="required"></dxi-validation-rule>
                                </dxi-column>
                            </dx-tree-list>
                        </div>
                        <div class="heading-wrapper d-flex justify-content-center align-items-center" *ngIf="DeliveryGroupList?.length == 0">
                            <h3 class="text-dark">{{ 'SETTING_PAGE.IDMS_SETTINGS.NO_DELIVERY_GROUPS_ADDED_YET' | transloco }}</h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- </form> -->
